import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

const userProfileSerializer = Serializers.object({
  legacyUserId: Serializers.integer,
  email: Serializers.string,
  firstName: Serializers.string,
  lastName: Serializers.string,
  pictureUrl: Serializers.string.nullable(),
});

export type UserProfile = SerializerValue<typeof userProfileSerializer>;

const userProfileListSerializer = Serializers.object({
  items: Serializers.array(userProfileSerializer),
  count: Serializers.integer,
});

export const profileActions = {
  userProfilesQuery: HttpAction({
    path: "/userProfiles",
    method: "get",
    requiresAuth: true as const,
    qsSerializer: Serializers.object({
      legacyUserIds: Serializers.integer.array().asJsonString(),
      emails: Serializers.string.array().asJsonString(),
    }).partial(),
    valueSerializer: userProfileListSerializer,
  }),
};
